const auctionContractAddress = "0x9773e24ee10be2CA9D6F068DC5F461aE26636Ed1"// normal Auction

export default auctionContractAddress